module.exports = __webpack_public_path__ + "img/mockup2.5e107192.jpg";